module.exports = __webpack_public_path__ + "static/media/circle-empty.fa42fb41.svg";